<template>
	<div class="summary">
		<div class="count">
			Gevonden {{ type }}:
			<strong>{{ total }}</strong>
		</div>

		<div v-if="typeof $slots.buttons !== 'undefined'" class="buttons">
			<slot name="buttons"></slot>
		</div>
	</div>
</template>

<script lang="ts" setup>
	defineProps({
		total: {
			type: Number,
			required: true
		},
		type: {
			type: String,
			default: 'items'
		}
	});
</script>

<style scoped>
	.summary {
		padding: 20px 10px 10px;
		font-size: var(--font-size-p-4);
		line-height: var(--line-height-p-4);

		display: grid;
		grid-template-columns: 1fr;
		align-items: start;
		grid-gap: 10px;

		@media screen and (min-width: 768px) {
			padding: 20px 10px;
			grid-template-columns: 1fr auto;
		}
	}

	.count {
		@media screen and (min-width: 768px) {
			padding: 20px 0 0;
		}
	}

	.summary strong {
		display: inline-block;
		margin-left: 4px;
	}

	.buttons {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}
</style>
